<template>
    <div class="online_success" v-loading="loading">
        <div class="online_success_box">
            <!-- <div class="titles_box">确认结算相关信息</div>
            <div class="form_box">
                <div class="forms">
                    <div class="form_title"><span>*</span>真实姓名</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="forms">
                    <div class="form_title"><span>*</span>手机号</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="forms">
                    <div class="form_title"><span>*</span>电子邮箱</div>
                    <div class="form_input">
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                </div>
            </div> -->
            <div class="titles_box">支付</div>
            <div class="check_box">
                <div class="checks">
                    <div class="check_title">支付方式：</div>
                    <div class="check_check">
                        <div class="items_flex" v-for="(item, index) in pay_list" :key="index"
                            @click="handle_pay(item, index)">
                            <div class="item_check">
                                <img src="@/assets/img/index/legal/checks_no.png" alt="" v-if="pay_ac != index">
                                <img src="@/assets/img/index/legal/checks_ac.png" alt="" v-if="pay_ac == index">
                            </div>
                            <div class="item_img">
                                <img :src="item.images" alt="">
                            </div>
                            <div class="item_title">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="checks" v-if="pay_ac==3">
                    <div class="check_title"></div>
                    <div class="check_check4">
                        <div class="form_flex">
                            <div class="form_text">收款单位名称：</div>
                            <div class="form_text2">{{ setting.bankCompany }}</div>
                        </div>
                        <div class="form_flex">
                            <div class="form_text">收款单位账号：</div>
                            <div class="form_text2">{{ setting.bankCode }}</div>
                        </div>
                        <div class="form_flex">
                            <div class="form_text">开户银行：</div>
                            <div class="form_text2">{{ setting.bankName }}</div>
                        </div>
                        <div class="form_flex">
                            <div class="form_text">上传凭证：</div>
                            <div class="form_text3">
                                <div class="up_btns" @click="handle_img_add">
                                    <img src="@/assets/img/index/comments_case/file_up.png" alt="">
                                    上传
                                </div>
                                <div class="text3_text">
                                    （请上传png、jpg、pdf文件等，可以在1M内上传）
                                </div>
                                <div class="text3_file" v-if="up_file.name">
                                    {{ up_file.name }}
                                    <img src="@/assets/img/index/comments_case/clear.png" alt="" @click="up_file={}">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="checks">
                    <div class="check_title">是否开票：</div>
                    <div class="check_check2">
                        <!-- 是否开票 1是0否 -->
                        <el-radio v-model="kp_ac" :label="0">不需要开票</el-radio>
                        <el-radio v-model="kp_ac" :label="1">需要开票</el-radio>
                    </div>
                </div>
                <div class="checks" v-if="kp_ac==1">
                    <div class="check_title"></div>
                    <div class="check_check3">
                        <div class="fp_list" v-for="(item, index) in fp_list" :key="index"
                            @click="handle_fp(item, index)">
                            <div class="fp_check">
                                <img src="@/assets/img/index/legal/fp_ac.png" alt="" v-if="item.id == fp_ac">
                                <img src="@/assets/img/index/legal/fp_no.png" alt="" v-if="item.id != fp_ac">
                            </div>
                            <div class="fp_info">
                                <div class="info_name" v-if="item.type==1">{{ item.taitou }}</div>
                                <div class="info_name" v-if="item.type==2">{{ item.company }}</div>
                                <div class="info_nums">税号：{{ item.taxpayer_number }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="titles_box">订单商品</div>
            <div class="table_box">
                <!-- @header-row-class-name="header_row_class_name" -->
                <el-table :data="shop_list" height="250"style="width: 100%" :header-row-class-name="'table_titles'" >  
                    <el-table-column prop="date" label="产品名称" width="500" :header-align="'left'">
                        <template slot-scope="scope">
                            <div class="cp_name">
                                <div class="imgs">
                                    <!-- <img src="../../assets/img/index/legal/shops.png" alt=""> -->
                                     <img :src="scope.row.thumb" alt="">
                                </div>
                                {{scope.row.title}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="价格" width="180">
                        <template slot-scope="scope">
                            <div class="prices">
                                ￥{{ scope.row.price }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="数量">
                        <template slot-scope="scope">
                            <div class="nums">
                                X1
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="小计">
                        <template slot-scope="scope">
                            <div class="prices">
                                ￥{{ scope.row.price }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="price_box">
                    <div class="price_text">合计：</div>
                    <div class="price_num">￥{{  shop_price }}</div>
                </div>
                <div class="yqm_box">
                    <div class="yqm_titles">邀请码</div>
                    <div class="yqm_inputs">
                        <el-input v-model="input" :disabled="user_info.shangji_id" placeholder="请输入邀请码"></el-input>
                    </div>
                </div>
                <div class="btns_flex">
                    <div class="btns1" @click="handle_black">返回</div>
                    <div class="btns2" @click="handle_end">去支付</div>
                </div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import upload from '@/components/upload/upload.vue'



export default {
    components: {
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png','pdf','docx']),

            loading: false,
            input: '',
            pay_ac: 0,
            pay_list: [
                {
                    title: '微信支付',
                    images: require('../../assets/img/index/legal/pay_wx.png'),
                },
                {
                    title: '支付宝支付',
                    images: require('../../assets/img/index/legal/pay_zfb.png'),
                },
                {
                    title: '网银支付',
                    images: require('../../assets/img/index/legal/pay_wy.png'),
                },
                {
                    title: '线下转款',
                    images: require('../../assets/img/index/legal/pay_xx.png'),
                },
                {
                    title: '佣金支付',
                    images: require('../../assets/img/index/legal/pay_yj.png'),
                },
            ],
            kp_ac: 1,//  0不需要发票 1需要发票
            fp_ac: 0,
            fp_list: [],
            shop_list: [],
            setting:{},
            up_file:{},
            code:'',//邀请码
            user_info:{},
        }
    },
    computed: {
        shop_price(){
            let price=0
            this.shop_list.forEach((e)=>{
                price+=e.price
            })
            return price
        },
    },
    watch: {

    },
    created() {
        this.get_invoiceList()
        this.get_detial()
        this.get_setting()
        this.get_user_info()
    },
    methods: {
        get_user_info(){
             this.$api("getUserInfo", {

            }, "get").then((res) => {
                this.loading = false
                console.log('用户信息', res)
                if (res.code == 1) {
                    this.user_info=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_setting(){
            this.loading=true
            this.$api("setting", {
				 
			}, "get").then((res) => {
                this.loading = false
                console.log('配置',res)
                if (res.code == 1) {
                    this.setting=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_detial(){
            this.loading=true
            this.$api("serveProInfo", {
               id:this.$route.query.pro_id,
			}, "get").then((res) => {
                this.loading = false
                console.log('服务详情',res)
                if (res.code == 1) {
                    let data=res.data
                    if(data.if_jifen){
                        data.price=Number(data.money)
                    }
                    this.shop_list=[data]
                   
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
         //触发上传
         handle_img_add(text){
            let datas={
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            console.log('res_data',res_data)
            this.up_file=res_data
        },
        handle_detial() {

        },
        handle_pay(item, index){
            this.pay_ac=index
        },
        handle_fp(item, index){
            this.fp_ac=item.id

        },
        //返回首页
        handle_black() {
            this.$router.push({
                path: '/home'
            })
        },
        handle_end(item, index) {
            if(this.kp_ac==1){
                if(!this.fp_ac){
                    alertErr('请选择发票')
                    return
                }
            }
            console.log('this.up_file.path',this.up_file.path)
            console.log('this.pay_ac',this.pay_ac)

            if(this.pay_ac==3){
                if(!this.up_file.path){
                    alertErr('请上传凭证')
                    return
                }
            }
            this.loading=true
            this.$api("appointSub", {
				order_id:this.$route.query.order_id,
                pay_type:Number(this.pay_ac)+1,
                if_kaipiao:this.kp_ac,
                fapiao_id:this.fp_ac,
                pro_id:this.$route.query.pro_id,
                yqm:this.code,
			}, "post").then((res) => {
                this.loading = false
                console.log('案由支付',res)
                if (res.code == 1) {
                    if(this.pay_ac==0){
                        console.log('微信支付')
                        this.wx_pay(res.data)
                    }
                    if(this.pay_ac==1){
                        console.log('支付宝支付')
                        this.zfb_pay(res.data)
                    }
                    if(this.pay_ac==2){
                        console.log('网银支付')
                        this.wy_pay(res.data)

                    }
                    if(this.pay_ac==3){
                        console.log('线下支付')
                        this.xx_pay(res.data)
                    }
                    if(this.pay_ac==4){
                        console.log('佣金支付')
                        this.yj_pay(res.data)
                    }
                    
                 
                      
                } else {
                    alertErr(res.msg)
                }
            });





            // this.$router.push({
            //     path: '/Legal_success'
            // })
        },
        // 微信支付
        wx_pay(data){
            this.loading=true
            this.$api("wxPay", {
				order_sn:data,//
                type:2,//1案例点评 2案源订单 3法律课堂 4案例库付费

			}, "post").then((res) => {
                this.loading = false
                console.log('微信支付',res,{
                    order_sn:data,//
                    order_id:this.$route.query.order_id,

                })
                if (res.code == 1) {
                    this.$router.push({
                        path: '/Legal_success',
                        query:{
                            order_sn:data,//
                            order_id:this.$route.query.order_id,
                        }

                    })
                      
                } else {
                    alertErr(res.msg)
                }
            });
        },
        // 支付宝支付
        zfb_pay(data){
            this.loading=true
            this.$api("aliPay", {
				order_sn:data,//
                type:2,//1案例点评 2案源订单 3法律课堂 4案例库付费

			}, "post").then((res) => {
                this.loading = false
                console.log('线下支付',res,{
                    order_sn:data,//
                    order_id:this.$route.query.order_id,

                })
                if (res.code == 1) {
                    this.$router.push({
                        path: '/Legal_success',
                        query:{
                            order_sn:data,//
                            order_id:this.$route.query.order_id,
                        }

                    })
                      
                } else {
                    alertErr(res.msg)
                }
            });
        },
        // 网银支付
        wy_pay(data){
            this.loading=true
            this.$api("webPay", {
				order_sn:data,//
                type:2,//1案例点评 2案源订单 3法律课堂 4案例库付费

			}, "post").then((res) => {
                this.loading = false
                console.log('线下支付',res,{
                    order_sn:data,//
                    order_id:this.$route.query.order_id,

                })
                if (res.code == 1) {
                    this.$router.push({
                        path: '/Legal_success',
                        query:{
                            order_sn:data,//
                            order_id:this.$route.query.order_id,
                        }

                    })
                      
                } else {
                    alertErr(res.msg)
                }
            });
        },
        // 线下支付
        xx_pay(data){
            this.loading=true
            this.$api("offlinePay", {
				order_sn:data,//
                pay_img:this.up_file.path,
                type:2,//1案例点评 2案源订单 3法律课堂 4案例库付费

			}, "post").then((res) => {
                this.loading = false
                console.log('线下支付',res,{
                    order_sn:data,//
                    order_id:this.$route.query.order_id,

                })
                if (res.code == 1) {
                    this.$router.push({
                        path: '/Legal_success',
                        query:{
                            order_sn:data,//
                            order_id:this.$route.query.order_id,
                        }

                    })
                      
                } else {
                    alertErr(res.msg)
                }
            });
 
        },
        // 佣金支付
        yj_pay(data){
            this.loading=true
            this.$api("yongjinPay", {
				order_sn:data,//
                type:2,//1案例点评 2案源订单 3法律课堂 4案例库付费
			}, "post").then((res) => {
                this.loading = false
                console.log('线下支付',res,{
                    order_sn:data,//
                    order_id:this.$route.query.order_id,

                })
                if (res.code == 1) {
                    this.$router.push({
                        path: '/Legal_success',
                        query:{
                            order_sn:data,//
                            order_id:this.$route.query.order_id,
                        }

                    })
                      
                } else {
                    alertErr(res.msg)
                }
            });
        },

        get_invoiceList(){
            this.loading=true
            this.$api("invoiceList", {
                limit:1000,
			}, "get").then((res) => {
                this.loading = false
                console.log('发票列表',res)
                if (res.code == 1) {
                    this.fp_list=res.data.data
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
      

    },

}
</script>
<style scoped lang="less">
.online_success {
    width: 100%;
    //    height: 600px;
    background-color: #FFFFFF;
    padding-bottom: 100px;

    .online_success_box {
        width: 1440px;
        height: 100%;
        padding-top: 30px;
        margin: auto;

        .titles_box {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;
            padding-bottom: 16px;
            border-bottom: 2px solid #D5D8DE;
        }

        .form_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 24px;
            padding-bottom: 48px;

            .forms {
                .form_title {

                    font-weight: normal;
                    font-size: 14px;
                    color: #666666;

                    span {
                        color: #FD4C5C;
                    }

                }

                .form_input {
                    width: 440px;
                    height: 44px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    margin-top: 17px;
                }
            }
        }

        .check_box {
            padding: 0 32px;

            .checks {
                display: flex;
                align-items: center;
                padding-top: 43px;

                .check_title {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    width: 80px;
                }

                .check_check {
                    display: flex;

                    .items_flex {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        margin-right: 80px;

                        .item_check {
                            display: flex;
                            align-content: center;

                            img {
                                width: 21px;
                                height: 21px;
                            }
                        }

                        .item_img {
                            margin-left: 16px;

                            img {
                                width: 39px;
                            }
                        }

                        .item_title {
                            padding-left: 10px;
                            font-weight: 400;
                            font-size: 16px;
                            color: #000000;

                        }
                    }


                }

                .check_check2 {}

                .check_check3 {
                    .fp_list {
                        width: 1288px;
                        height: 102px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #EAEBEE;
                        margin-bottom: 20px;
                        padding: 27px 17px;
                        cursor: pointer;
                        display: flex;

                        // align-items: center;
                        .fp_check {
                            width: 18px;
                            height: 18px;
                            flex-shrink: 0;

                            img {
                                width: 18px;
                                height: 18px;
                            }
                        }

                        .fp_info {
                            flex: 1;
                            display: flex;
                            // align-items: center;
                            flex-wrap: wrap;
                            align-content: space-between;
                            padding-left: 25px;

                            .info_name {
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;

                            }

                            .info_nums {
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                    }
                }

                .check_check4{
                    .form_flex{
                        margin-bottom: 20px;
                        display: flex;
                        // align-items: center;
                        .form_text{
                            width: 100px;
                            text-align: right;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;

                        }
                        .form_text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }
                        .form_text3{
                            .up_btns{
                                width: 88px;
                                height: 28px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #377CFD;
                                img{
                                    width: 11px;
                                    height: 11px;
                                    margin-right: 8px;
                                }
                            }
                            .text3_text{
                                font-family: SourceHanSansSC-Regular, SourceHanSansSC-Regular;
                                font-weight: normal;
                                font-size: 12px;
                                color: #999999;
                                margin-top: 11px;
                            }
                            .text3_file{
                                display: flex;
                                align-items: center;
                                margin-top: 4px;
                                font-family: SourceHanSansSC-Regular, SourceHanSansSC-Regular;
                                font-weight: normal;
                                font-size: 14px;
                                color: #333333;
                                img{
                                    margin-left: 25px;
                                    width: 12px;
                                    height: 12px;
                                    cursor: pointer;                                    
                                }
                            }
                        }
                    }
                }
            }
        }
        .table_box{
            padding-top: 24px;
            /deep/.el-table{
                .el-table__header-wrapper{
                    .table_titles{
                        .el-table__cell{
                            background-color: #FAFBFC;
                            .cell{
                                text-align: left;
                                padding-left: 48px;
                            }
                        }
                    }
                }
                .cp_name{
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    padding-left: 48px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;

                    .imgs{
                        width: 64px;
                        height: 64px;
                        // margin-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
                .prices{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    text-align: left;
                    padding-left: 28px;

                }
                .nums{
                    padding-left: 48px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: left;

                }
            }
            .price_box{
                width: 1440px;
                height: 56px;
                background: #FAFAFA;
                border-radius: 0px 0px 0px 0px;
                display:flex;
                align-items: center;
                justify-content: end;
                padding: 0 40px;
                .price_text{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;

                }
                .price_num{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #377CFD;
                }
            }
            .yqm_box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-top: 25px;
                .yqm_titles{
                   
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    margin-right: 18px;
                }
                .yqm_inputs{

                }
            }
            .btns_flex{
                display: flex;
                align-items: center;
                justify-content: end;
                padding-top: 24px;
                .btns1{
                    width: 191px;
                    height: 46px;
                    background: #FFFFFF;
                    border: 1px solid #377CFD;
                    cursor: pointer;
                    text-align: center;          
                    line-height: 46px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #377CFD;
                    border-radius: 8px;

                }
                .btns2{
                    width: 191px;
                    height: 46px;
                    background: #377CFD; 
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 46px;
                    cursor: pointer;
                    text-align: center;
                    border-radius: 8px;
                    margin-left:24px ;
                }
            }
        }
    }
}
</style>